import { jsx as _jsx } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { Txt } from "@jti/ui";
import styles from "./ProductDescription.module.scss";
const { sanitize } = dompurify;
export const ProductDescription = ({ description }) => {
    return (_jsx(Txt, { variant: "txt-1", children: _jsx("div", { className: styles.description, dangerouslySetInnerHTML: { __html: sanitize(description) } }) }));
};
//# sourceMappingURL=ProductDescription.js.map